<template>
  <div>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col md="12" cols="12">
            <ModuleHeader>Resumen de ventas</ModuleHeader>
          </v-col>
          <v-col md="4" cols="12">
            <v-card>
              <v-card-text>
                <h2>Ventas</h2>
                <h1 class="mt-0">{{ $pgsHelper.formatNumber(totalSales) }}</h1>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col md="4" cols="12">
            <v-card>
              <v-card-text>
                <h2>Total</h2>
                <h1 class="mt-0">
                  $ {{ $pgsHelper.formatNumber(totalAmount) }}
                </h1>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col md="4" cols="12">
            <v-card>
              <v-card-text>
                <h2>Productos vendidos</h2>
                <h1 class="mt-0">{{ $pgsHelper.formatNumber(totalItems) }}</h1>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col md="6" cols="12">
            <div id="chart-container">
              <fusioncharts :type="'column2d'" :width="'100%'" :height="'400'" :renderAt="'chart-container'"
                :dataformat="'json'" :dataSource="data">
              </fusioncharts>
            </div>
          </v-col>
          <v-col md="6" cols="12">
            <div id="chart-containerCategoria">
              <fusioncharts :type="'column2d'" :width="'100%'" :height="'400'" :renderAt="'chart-containerCategoria'"
                :dataformat="'json'" :dataSource="dataCategoria">
              </fusioncharts>
            </div>
          </v-col>

        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import moment from "moment";
import Currencies from "../../clases/Currencies.js";
// Include the core fusioncharts file from core
//import FusionCharts from "fusioncharts/core";
// Include the chart from viz folder
/*import Column2D from "fusioncharts/viz/column2d";
// Include the fusion theme
import FusionTheme from "fusioncharts/themes/es/fusioncharts.theme.fusion";
// Add the chart and theme as dependency
// E.g. FusionCharts.addDep(ChartType)
FusionCharts.addDep(Column2D);
FusionCharts.addDep(FusionTheme);*/
export default {
  name: "SaleStats",
  components: {},
  props: ["ventas", "initDate", "endDate"],
  data() {
    return {
      Currencies: Currencies,
      totalSales: 0,
      totalAmount: 0,
      totalItems: 0,
      ventaHoras: [],
      data: {},
      dataCategoria: {}
    };
  },
  computed: {},
  methods: {
    genArrayByHours(start, end) {
      let hourArray = [];
      if (start && end) {
        let hourArray = [];
        let auxDate = new moment(start, "YYYY-MM-DD HH:mm");
        let endDate = new moment(end, "YYYY-MM-DD HH:mm");
        for (
          let i = 0;
          auxDate.format("YYYY-MM-DD HH:mm") <=
          endDate.format("YYYY-MM-DD HH:mm");
          i++
        ) {
          hourArray.push({
            value: 0,
            totalVenta: 0,
            label: auxDate.format("HH:mm"),
          });
          auxDate = auxDate.add(60, "minutes");
        }
        return hourArray;
      }
    },
    initData() {
      // se acumula en variables locales: escribir this.* en cada venta dispara el sistema reactivo
      let totalAmount = 0;
      let totalItems = 0;
      const totalSales = this.ventas.length;
      let modeChart = "day";
      let arrayData = [];
      let gruperByCategoria = [];
      const categoriaIndex = new Map();
      /*En caso de ser distintos dias */
      const isHourMode = this.initDate == this.endDate;
      // label -> grupo, evita buscar linealmente por cada venta
      const groupIndex = new Map();
      if (isHourMode) {
        modeChart = "hour";
        // el ordenamiento solo sirve para conocer la primera y última hora
        const orderedVentas = this.$_.orderBy(this.ventas, "FechaCreacion", "asc");
        /*Primera y ultima hora de venta para array de ventas por hora*/
        let initialHour = false;
        let endHour = false;
        if (orderedVentas[0]) {
          initialHour = new moment(orderedVentas[0].FechaCreacion).format(
            "YYYY-MM-DD HH:00"
          );
        }
        if (orderedVentas[orderedVentas.length - 1]) {
          endHour = new moment(
            orderedVentas[orderedVentas.length - 1].FechaCreacion
          ).format("YYYY-MM-DD HH:00");
        }

        arrayData = this.genArrayByHours(initialHour, endHour);
        (arrayData || []).forEach((g) => {
          if (!groupIndex.has(g.label)) groupIndex.set(g.label, g);
        });
      }
      try {
        this.ventas.forEach((venta) => {
          let prod = Object.entries(venta.Catalogo);
          totalItems += prod.length;
          let devo = 0;
          if (venta.Devos) {
            for (const key in venta.Devos) {
              let devolucionKey = key.split("_");

              if (devolucionKey[1] == this.Currencies.getCurrencyDefault()) {
                devo = devo + venta.Devos[key];
              } else {
                devo =
                  devo +
                  this.Currencies.getExchangeRateByCurrency(
                    venta.Devos[key],
                    devolucionKey[1],
                    this.Currencies.getCurrencyDefault(),
                    venta.TipoCambio
                  );
              }
            }
          }
          const total = Number(venta.Total - devo);
          totalAmount += total;
          if (isHourMode) {
            //agrupado por hora de venta
            const grupo = groupIndex.get(
              new moment(venta.FechaCreacion).format("HH:00")
            );
            if (grupo) {
              grupo.value += total;
              grupo.totalVenta += 1;
            }
          } else {
            const ventaDate = new moment(venta.FechaCreacion).format("YYYY-DD-MM");
            const grupo = groupIndex.get(ventaDate);
            if (grupo) {
              grupo.value += total;
              grupo.totalVenta += 1;
            } else {
              const nuevo = { label: ventaDate, value: total, totalVenta: 1 };
              arrayData.push(nuevo);
              groupIndex.set(ventaDate, nuevo);
            }
          }

          venta.Catalogo.forEach((prod) => {
            if (prod.Id.includes("Reserva")) {
              if (prod.Orn != "Golf") {
                prod.Familia.N = prod.Orn;
                prod.Familia.I = prod.Orn;
                prod.Categoria.N = prod.Orn;
              }
            }
            if (prod.Id.includes("RVA-ExtraRidder")) {
              prod.Nombre = "Extra rider";
              prod.Categoria.N = "EXTRA RIDER";
              prod.Categoria.I = "EXTRA RIDER";
              prod.Familia.N = "EXTRA RIDER";
              prod.Familia.I = "EXTRA RIDER";
            }

            if (prod.Id.includes("RVA-Transportacion")) {
              prod.Nombre = "Transportacion";
              prod.Categoria.N = "TRANSPORTACION";
              prod.Categoria.I = "TRANSPORTACION";
              prod.Familia.N = "TRANSPORTACION";
              prod.Familia.I = "TRANSPORTACION";
            }

            if (prod.Tip == "Cupon") {
              prod.Categoria.N = "Paquetes Rondas de Golf";
              prod.Categoria.I = "Paquetes Rondas de Golf";
              prod.Familia.N = "Paquetes Rondas de Golf";
              prod.Familia.I = "Paquetes Rondas de Golf";
            }
            let precio = 0;
            if (prod.Pagos) {
              Object.values(prod.Pagos).forEach((pago) => {
                precio += pago.def.C;
              });
            }
            const grupoCat = categoriaIndex.get(prod.Categoria.N);
            if (grupoCat) {
              grupoCat.value += Number(precio);
              grupoCat.totalVenta += 1;
            } else {
              const label = prod.Categoria.N.replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '');
              const nuevo = { label, value: Number(precio), totalVenta: 1 };
              gruperByCategoria.push(nuevo);
              if (!categoriaIndex.has(label)) categoriaIndex.set(label, nuevo);
            }
          });
        });
      } catch (e) {
        console.log(e)
      }
      this.totalSales = totalSales;
      this.totalAmount = totalAmount;
      this.totalItems = totalItems;
      this.data = this.initCharts(arrayData, modeChart);
      this.dataCategoria = this.initChartsCategorie(gruperByCategoria);
    },
    initCharts(chartData, modeChart) {
      let ventaPorHora;
      if (chartData) {
        chartData.forEach((data) => {
          data.displayValue = "$" + this.$pgsHelper.formatNumber(data.value);
        });
      }

      let caption = "";
      let xAxisName = "";
      if (modeChart == "day") {
        chartData = this.$_.orderBy(chartData, "label", "asc");
        caption = "Ventas por dia";
        xAxisName = "Dias de venta";
      } else {
        caption = "Ventas por hora";
        xAxisName = "Horas de venta";
      }

      return {
        chart: {
          plottooltext:
            "<div>$label:</div><hr class='demo'>Total : <b>$dataValue</b>",
          baseFontSize: "15",
          rotateValues: "0",
          minAngleForValue: "75",
          valueFontSize: "15",
          showValues: "0",
          //Set the chart caption
          caption: caption,
          //Set the chart subcaption
          subCaption: "",
          //Set the x-axis name
          xAxisName: xAxisName,
          //Set the y-axis name
          yAxisName: "Venta",
          numberSuffix: "$",
          scrollPosition: "top",
          //Set the theme for your chart
          theme: "fusion",
        },
        // Chart Data from Step 2
        data: chartData,
      }
      /*var chartInstance = new FusionCharts(chartConfig);
      chartInstance.render();*/
    },
    initChartsCategorie(chartData) {
      let ventaPorHora;
      chartData.forEach((data) => {
        data.displayValue = "$" + this.$pgsHelper.formatNumber(data.value);
      });

      chartData = this.$_.orderBy(chartData, "value", "asc");

      return {
        chart: {
          plottooltext:
            "<div>$label:</div><hr class='demo'>Total : <b>$dataValue</b>",

          rotateValues: "0",
          minAngleForValue: "75",
          valueFontSize: "15",
          showValues: "0",
          //Set the chart caption
          caption: "Venta por categoria",
          //Set the chart subcaption
          subCaption: "",
          //Set the x-axis name
          xAxisName: "Categoria",
          //Set the y-axis name
          yAxisName: "Venta",
          numberSuffix: "$",
          scrollPosition: "top",
          //Set the theme for your chart
          theme: "fusion",
        },
        // Chart Data from Step 2
        data: chartData,
      }
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
